import React from 'react';
import useNFCListener from '../hooks/useNFCListener';

/**
 * Composant wrapper pour activer le listener NFC global
 * Doit être utilisé à l'intérieur d'un Router
 */
const NFCListenerWrapper = ({ user, children }) => {
  // Activer le listener NFC global
  useNFCListener(user);

  // Rendre les enfants normalement
  return <>{children}</>;
};

export default NFCListenerWrapper;
